import { BrowserAndPhysicsLoadable } from './browser-and-physics-loadable';

export class Object3DPage {
    content: BrowserAndPhysicsLoadable[];
    currentPage: number;
    totalItems: number;
    totalPages: number;
}
